// extracted by mini-css-extract-plugin
module.exports = {"sign_up":"SignUp_sign_up__3i_0V","already_have_account":"SignUp_already_have_account__b7__1"};